export default {
  id: 'vitalSign/BODY_TEMPERATURE/v1',
  formSchema: {
    title: 'encounter:widget.vitalSigns.bodyTemperature',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'number',
        minimum: 1,
        maximum: 999,
        title: 'encounter:widget.vitalSigns.bodyTemperature'
      }
    },
    iconClass: 'icon-thermometer',
    measurement: 'ºC'
  },
  uiSchema: {
    id001: { 'ui:widget': 'customI18nNumericWidget' },
    'x-customClass': 'vital-signs-widget',
    'x-cancelBtnSize': 'sm',
    'x-saveBtnSize': 'sm'
  }
};
